"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _ShellIndexRows = require("web/shared/shell/ShellIndexRows.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A shell's destinations on a phone: compact rows in their groups, each a
* whole-row link with a line under its name saying what is there, and the
* chevron that says it opens a screen of its own. After them come any
* groups the shell draws rows for itself, such as an action, headed and
* spaced as every other group is.
*/
function ShellIndexRows(_ref) {
  let groups = _ref.groups,
    trailingGroups = _ref.trailingGroups,
    onNavigate = _ref.onNavigate;
  const destinationGroups = groups.map(group => ({
    key: group.heading,
    heading: group.heading,
    pinnedToEnd: false,
    rows: group.destinations.map(destination => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.item)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
        to: destination.path,
        onClick: () => onNavigate(destination)
      }, stylex.props(_ShellIndexRows.styles.row)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.glyph)), {}, {
          "aria-hidden": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: destination.icon,
            size: "m"
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.text)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.label)), {}, {
            children: destination.label
          })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.description)), {}, {
            children: destination.description
          }))]
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.glyph)), {}, {
          "aria-hidden": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: "chevron-right",
            size: "s"
          })
        }))]
      }))
    }), destination.key))
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: [...destinationGroups, ...trailingGroups].map(group => /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.group)), {}, {
      children: [group.heading == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.heading)), {}, {
        children: group.heading
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows.styles.list)), {}, {
        children: group.rows
      }))]
    }), group.key))
  });
}
var _default = exports.default = ShellIndexRows;